import clsx from 'clsx';
import { endOfDay } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import {
  SiRequestStatus,
  SiService,
  siteIntelligenceServiceLabel,
} from '../../../../../pages/siteIntelligence/mappings';
import MultiSelection from '../../components/MultiSelection';
import SearchInputGroup from '../../components/SearchInputGroup';
import SingleSelection from '../../components/SingleSelection';
import { useFilter } from '../../FilterContext';
import DatePickerFilter from '../components/DatePickerFilter';

export function ReviewHistoryFilter() {
  const params = useParams();
  const intl = useIntl();
  const { globalFilter, setGlobalFilter } = useFilter();
  const filterKey = 'siReviewHistoryList';

  return (
    <>
      <div className={clsx(params.id ? 'blur' : '')}>
        <div className='d-inline-flex flex-wrap'>
          {/* Select */}
          <div className='d-inline-flex flex-wrap pb-2'>
            {/* Date Picker */}
            <DatePickerFilter
              onChange={(selectedDate) =>
                setGlobalFilter({
                  ...globalFilter,
                  [filterKey]: {
                    ...globalFilter?.[filterKey],
                    request_date: selectedDate && {
                      from: zonedTimeToUtc(new Date(selectedDate.start), 'Hongkong').toISOString(),
                      to: zonedTimeToUtc(
                        new Date(endOfDay(selectedDate.end)),
                        'Hongkong'
                      ).toISOString(),
                    },
                  },
                })
              }
              globalFilterValue={
                globalFilter?.[filterKey]?.request_date?.from &&
                globalFilter?.[filterKey]?.request_date?.to && {
                  startDate: new Date(globalFilter?.[filterKey]?.request_date?.from),
                  endDate: new Date(globalFilter?.[filterKey]?.request_date?.to),
                }
              }
              label='Request Date'
              placeholder='Filter Request Date'
              className='me-6'
            />

            {/* Service */}
            {/* <MultiSelection
              title='Search Type'
              globalFilterValue={globalFilter?.[filterKey]?.['queries.service']?.values}
              options={serviceOptions}
              onChange={(e) => {
                setGlobalFilter({
                  ...globalFilter,
                  [filterKey]: {
                    ...globalFilter?.[filterKey],
                    'queries.service': { type: 'in', values: e },
                  },
                });
              }}
            /> */}
          </div>
        </div>

        {/* Search */}
        <SearchInputGroup
          inputs={[
            {
              key: 'queries.query.value',
              title: 'URL',
              minWidth: 100,
            },
            {
              key: 'request_id',
              title: 'Request ID',
              minWidth: 50,
              maxWidth: 150,
            },
            {
              key: 'merchant_name',
              title: 'Client Name',
              minWidth: 100,
              maxWidth: 150,
            },
            // {
            //   key: 'merchant_id',
            //   title: 'Client ID',
            //   minWidth: 100,
            //   maxWidth: 150,
            // },
            // {
            //   key: 'request_info.company_name',
            //   title: 'Company',
            //   minWidth: 100,
            //   maxWidth: 175,
            // },
            {
              key: 'request_info.group_name',
              title: 'Group',
              minWidth: 100,
              maxWidth: 175,
            },
            {
              key: 'remark',
              title: 'Remark',
              minWidth: 100,
              maxWidth: 100,
            },
          ]}
          section={filterKey}
          globalFilterValue={globalFilter}
          onSubmit={(searchValues) =>
            setGlobalFilter({
              ...globalFilter,
              [filterKey]: { ...globalFilter?.[filterKey], ...searchValues },
            })
          }
          onClear={(searchValues) =>
            setGlobalFilter({
              ...globalFilter,
              [filterKey]: { ...globalFilter?.[filterKey], ...searchValues },
            })
          }
        />
      </div>
    </>
  );
}
